export default __webpack_public_path__ + "static/media/Icon-Linkedin.91d4cc20.svg";